import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Link from 'valuelink';
import { Popconfirm, message, Button } from 'antd';
import { Input } from 'valuelink/lib/tags';
import { RegularText, SemiboldText } from '../../components/common/Text';
import { setDoctorProfile } from '../../actions/index';
import {
  fetchDoctorServices,
  deleteService,
  updateService,
} from '../../services';

const OuterContainer = styled.div`
  display: flex;
  flex: 1 0;
  flex-direction: column;
  justify-content: center;
  /* align-items: center; */
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
`;

const TitleText = styled(SemiboldText)`
  font-size: 1.5rem;
  text-align: center;
  color: #666569;
`;

const ColContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const BodyContainer = styled.div`
  display: flex;
  flex: 1 0;
  flex-direction: column;
  align-items: stretch;
  margin-bottom: 20px;
  /* over */
`;

const StyledInputBox = styled(Input)`
  font-size: 16px !important;
  background-color: #f8f8f8;
  align-self: stretch;
  border-radius: 6px;
  flex: 1;
  flex-shrink: 0;
  min-width: 180px;
  /* max-width: 380px; */
  height: 44px;
  padding: 6px 12px;
  align-items: center;
  margin-bottom: 10px;
`;

const LabelText = styled(SemiboldText)`
  font-size: 12px;
  text-align: center;
  margin-bottom: 0.25rem;
  margin-top: 0.625rem;
  color: #7c7c7c;
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
`;

const ServiceRow = styled.div`
  display: flex;
  flex-direction: row;
  margin: 16px;
  padding: 8px;
  box-shadow: 0 3px 5px 2px rgba(0, 0, 0, 0.1);
  border-radius: 0.5rem;
  align-items: center;
  justify-content: space-between;
`;

const ServiceNumber = styled(SemiboldText)`
  font-size: 16;
  color: #666569;
`;

const ServiceInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const ServiceText = styled(RegularText)`
  font-size: 14;
  color: #666569;
  margin: 0px 10px 0px 10px;
`;

const EduRowComponent = styled.div`
  display: flex;
  flex-direction: row;
`;

class DoctorServicesScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      services: [],
      doctorServiceId: null,
      title: '',
      formEditing: false,
    };
    console.log({ props });

    this.doctorId = props.doctorId;
  }

  componentDidMount = () => {
    this.fetchService();
  };

  componentDidUpdate = () => {
    if (document.getElementById('edit-form')) {
      document.getElementById('edit-form').scrollIntoView();
    }
  };

  fetchService = () => {
    const { dispatch } = this.props;
    fetchDoctorServices(this.doctorId).then(res => {
      const services = res.data;
      dispatch(setDoctorProfile({ services }));
      this.setState({
        services,
      });
    });
  };

  submit = () => {
    const { doctorServiceId, title } = this.state;

    updateService({
      doctorId: this.doctorId,
      doctorServiceId,
      title,
    })
      .then(() => {
        this.cancelEditing();
        this.fetchService();
      })
      .catch(err => {
        console.log({ err });
      });
  };

  deleteService = doctorServiceId => {
    deleteService(this.doctorId, doctorServiceId)
      .then(() => {
        message.success('Service deleted successfully');
        this.fetchService();
      })
      .catch(err => {
        console.log({ err });
      });
  };

  editService = edu => {
    this.setState({
      formEditing: true,
      doctorServiceId: edu.doctorServiceId,
      title: edu.title || '',
    });
  };

  cancelEditing = () => {
    this.setState({
      formEditing: false,
      doctorServiceId: null,
      title: '',
    });
  };

  render() {
    const { services } = this.state;
    const titleLink = Link.state(this, 'title');

    const servicesForm = () => {
      console.log({ state: this.state });
      return (
        <ServiceRow id="edit-form">
          <BodyContainer>
            <LabelText>Service Title</LabelText>
            <StyledInputBox
              className="visit-input"
              valueLink={titleLink}
              placeholder="Title"
            />

            <EduRowComponent>
              <Button
                type="primary"
                style={{ marginRight: 10 }}
                onClick={this.submit}
              >
                Submit
              </Button>
              <Button onClick={this.cancelEditing}>Cancel</Button>
            </EduRowComponent>
          </BodyContainer>
        </ServiceRow>
      );
    };

    const renderService = (edu, idx) => (
      <ServiceRow>
        <EduRowComponent>
          <ServiceNumber>{idx + 1}. </ServiceNumber>
          <ServiceInfo>
            <ServiceText>{edu.title}</ServiceText>
          </ServiceInfo>
        </EduRowComponent>
        <EduRowComponent>
          <Button
            type="primary"
            style={{ marginRight: 10 }}
            onClick={() => this.editService(edu)}
          >
            Edit
          </Button>
          <Popconfirm
            title="Are you sure delete this?"
            onConfirm={() => this.deleteService(edu.doctorServiceId)}
            // onCancel={cancel}
            okText="Yes"
            cancelText="No"
          >
            <Button type="danger">Delete</Button>
          </Popconfirm>
        </EduRowComponent>
      </ServiceRow>
    );

    return (
      <OuterContainer>
        <TitleText>Doctor Service Screen</TitleText>
        {!this.state.formEditing && (
          <Button
            style={{ alignSelf: 'center', flex: 0, padding: 4 }}
            onClick={() => this.editService({})}
          >
            Add Service
          </Button>
        )}
        {this.state.formEditing && servicesForm()}
        <ColContainer>{services.map(renderService)}</ColContainer>
      </OuterContainer>
    );
  }
}

const mapStateToProps = state => ({
  authToken: state.user.authToken,
});

export default connect(mapStateToProps)(DoctorServicesScreen);
